import { useQuery } from '@tanstack/react-query';

const fetchMealDetails = async (mealId) => {
  const res = await fetch(
    `https://www.themealdb.com/api/json/v1/1/lookup.php?i=${mealId}`
  );

  if (!res.ok) {
    throw new Error('Failed to load meal details');
  }

  const data = await res.json();
  return data.meals?.[0];
};

const MealModal = ({ mealId, onClose, onToggleFavorite, isFavorite }) => {
  const { data: meal, isLoading, isError, error } = useQuery({
    queryKey: ['mealDetails', mealId],
    queryFn: () => fetchMealDetails(mealId),
    enabled: !!mealId,
  });

  if (!mealId) {
    return null;
  }

  return (
    <div className="meal-modal-backdrop" onClick={onClose}>
      <div className="meal-modal" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="close-button" onClick={onClose}>
          ×
        </button>

        {isLoading ? (
          <p>Loading details…</p>
        ) : isError ? (
          <p className="error">Error: {error.message}</p>
        ) : !meal ? (
          <p>No meal details available.</p>
        ) : (
          <>
            <div className="meal-modal-header">
              <img src={meal.strMealThumb} alt={meal.strMeal} />
              <div>
                <h2>{meal.strMeal}</h2>
                <p>
                  {meal.strCategory} · {meal.strArea}
                </p>
              </div>
            </div>

            <button type="button" className="favorite-button" onClick={() => onToggleFavorite(meal)}>
              {isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
            </button>

            {meal.strTags && <p className="meal-tags">Tags: {meal.strTags.split(',').join(', ')}</p>}

            <section className="meal-instructions">
              <h3>Instructions</h3>
              <p>{meal.strInstructions}</p>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default MealModal;